// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getReqCategoriesApi } from "../../Service/Api/RequestCategoriesApi"
import { getRegCategoryList, getErrors} from "../Reducer/RequestCategoriesReducer"


// Watchers
function* reqCategoryListSaga() {
	yield takeEvery("reqCategory_list/getReqCategories", getAllReqCategories)
}

// Sagas
function* getAllReqCategories(action) {
	// console.log(action)
	try {
		const getReqCategories = yield call(getReqCategoriesApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getReqCategories.request.status === 200) {
			yield put(getRegCategoryList(getReqCategories))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(reqCategoryListSaga)])
}
